/* ** *** *** ***
Covetrus PCI/Security Notice:
This file has been identified as potentially impacting user and/or data security.
All modifications to these files must be reviewed and merged by a designated Security Champion for this application.
Additional information, including specifics for Pull Requests, can be found here:
https://dvmwiki.atlassian.net/wiki/spaces/MCT/pages/507511182/Code+Reviews
*** *** *** ** */

import axios from 'axios';

import { UPDATE_PAYMENT_OPTIONS } from './types';

const updatePaymentOptions = ({
  paymentProfileId,
  nameOnCard,
  creditCardNumber,
  expirationMonth,
  expirationYear,
  ccSecurityCode,
  distinctBillingAddress,
  billingAddress,
}) => ({
  type: UPDATE_PAYMENT_OPTIONS,
  payload: {
    paymentProfileId,
    nameOnCard,
    creditCardNumber,
    expirationMonth,
    expirationYear,
    ccSecurityCode,
    distinctBillingAddress,
    billingAddress,
  },
});

export const getNewPayment = (customer, paymentOptions) => {
  return new Promise((resolve, reject) => {
    axios
      .get(
        `${APIENDPOINT}/getPayments?profileId=${
          customer.authnetClientProfileId
        }&platformId=${customer.practicePlatformTypeId}`
      )
      .then(response => {
        if (response.status === 200) {
          const payments = response.data;
          if (payments && payments.length && paymentOptions) {
            const missingPaymentOptions = payments.filter(
              payment =>
                !paymentOptions
                  .map(option => option.paymentProfileId)
                  .includes(payment.paymentProfileId)
            );

            const newPaymentMap = missingPaymentOptions.map(paymentOption => {
              const newMapped = Object.assign({}, paymentOption, {
                nameOnCard: paymentOption.name,
              });
              delete newMapped.name;
              return newMapped;
            });
            resolve(newPaymentMap);
          } else {
            reject(new Error('There are no new payments to process'));
          }
        } else {
          reject(
            new Error(
              `Could not get new payments: ${response.status} ${
                response.statusText
              }`
            )
          );
        }
      });
  });
};

export default updatePaymentOptions;



// WEBPACK FOOTER //
// ./src/actions/userInformation/updatePaymentOptions.js